import { createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import TemplateShowcase from "#/components/cv-templates/Showcase";
import { metadataToHead, type PageMetadata } from "#/lib/seo";

export default function Page() {
  const links = [
    { href: "/nurse-salary-in-united-states", text: "Nurse Salary Guide" },
    { href: "/nurse-resume-examples", text: "Resume Examples" },
  ];

  return (
    <>
      <header>
        <NavBar overrideLinks={links} />
      </header>

      <main id="content" className="mx-auto mt-10 max-w-3xl space-y-10">
        <h1 className="px-5 text-center text-5xl">
          Resume Examples for Nurses
        </h1>

        <section className="mx-8 space-y-5">
          <p>
            You've worked way too hard to let a poorly formatted Resume hold you
            back. Use one of our templates designed for nurses and stand out
            from the stack of poorly designed resumes.
          </p>

          <p>
            Avoid being overlooked by keeping the hiring manager engaged while
            they learn why you're the one they've been looking for. This can be
            the difference between landing the dream position and experiencing
            the frustration of an unnecessarily long job search.
          </p>
        </section>

        <section className="mx-8 space-y-5">
          <h2 className="text-xl font-bold">Nurse Resume Templates</h2>
          <TemplateShowcase templates={templates} />
        </section>
      </main>
      <Footer fmBio />
    </>
  );
}

const templates = [
  {
    id: 1,
    title: "Modern Nurse Resume",
    imageUrl: "/nurse-cv-resume-example-template.png",
    description:
      "A sleek and modern design suitable for nurses at any career stage.",
  },
  {
    id: 2,
    title: "Elegant Professional Resume",
    imageUrl: "/nurse-cv-resume-example-template.png",
    description:
      "An elegant template that combines professionalism with a touch of sophistication.",
  },
  {
    id: 3,
    title: "Minimalist CV Design",
    imageUrl: "/nurse-cv-resume-example-template.png",
    description:
      "Perfect for those who prefer a minimalist and clean layout for their CV.",
  },
  {
    id: 4,
    title: "Locum Tenens Resume Template",
    imageUrl: "/nurse-cv-resume-example-template.png",
    description:
      "A dynamic layout that stands out, ideal for showcasing skills and experience.",
  },
  {
    id: 5,
    title: "Classic Nursing CV",
    imageUrl: "/nurse-cv-resume-example-template.png",
    description:
      "A classic template that emphasizes clarity and structure, great for traditional roles.",
  },
];

export const metadata: PageMetadata = {
  title: `${templates.length} Nurse Resume Examples in 2024`,
  description:
    "Stand out from the stack of boring CVs with our templates for nurses. Get the hiring manager's attention and keep'em engaged.",
  openGraph: {
    images: ["https://roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/nurse-resume-examples`,
  },
};

export const Route = createFileRoute("/(resume-examples)/nurse-resume-examples/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
